import React, { useState, useEffect } from "react";
import { DndContext, closestCenter, useSensor, useSensors, PointerSensor } from "@dnd-kit/core";
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useSelector } from "react-redux";
import { BiBookContent, BiEdit, BiTrash } from "react-icons/bi";
import { Popconfirm } from "antd";
import { useTranslation } from "react-i18next";
import { URL } from "../../api";
import { useNavigate } from "react-router-dom";

const ItemActions = ({ item, setModal, deleteData, contentTitle, contentUrl, setSelectedItem, navigation, t }) => {
    const handleEdit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        console.log('Edit button clicked for item:', item.id);
        setSelectedItem(item.id);
        setModal(true);
    };

    const handleDelete = () => {
        console.log('Delete confirmed for item:', item.id);
        deleteData(item.id);
    };

    const handleNavigate = (e) => {
        e.preventDefault();
        e.stopPropagation();

        console.log("Navigation clicked, going to:", `/slider-content/${item?.id}`);
        navigation(`${contentUrl}/${item?.id}`);
    };

    return (
        <div
            className="w150px"
            style={{
                position: 'relative',
                zIndex: 10
            }}
            onMouseDown={e => e.stopPropagation()}
            onMouseUp={e => e.stopPropagation()}
            onClick={e => e.stopPropagation()}
        >
            <div className="cp action-button mb-2">
                <button
                    type="button"
                    onClick={handleEdit}
                    className="d-flex align-items-center border-0 bg-transparent"
                >
                    <BiEdit
                        size={25}
                        color="#335CFF"
                        className="mr-1"
                    />
                    <span>{t("edit")}</span>
                </button>
            </div>

            {contentUrl ? <div className="cp mb-2 action-button">
                <button
                    type="button"
                    onClick={handleNavigate}
                    className="d-flex align-items-center border-0 bg-transparent"
                >
                    <BiBookContent
                        size={25}
                        className="text-warning mr-1"
                    />
                    <span>{contentTitle ?? t("content")}</span>
                </button>
            </div> : null}

            <div className="cp action-button">
                <Popconfirm
                    title={t("content_delete_desc")}
                    onConfirm={handleDelete}
                    okText={t("yes")}
                    cancelText={t("no")}
                >
                    <button type="button" className="d-flex align-items-center border-0 bg-transparent">
                        <BiTrash
                            size={25}
                            className="text-danger mr-1"
                        />
                        <span>{t("delete2")}</span>
                    </button>
                </Popconfirm>
            </div>
        </div>
    );
};

function SortableItem({ item, contentTitle, contentUrl, setModal, deleteData, setSelectedItem }) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({
        id: String(item.id),
        transition: {
            duration: 150,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        }
    });

    const lang = useSelector((state) => state.lang.lang);
    const navigation = useNavigate();
    const { t } = useTranslation();

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        padding: "12px",
        marginBottom: "8px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: isDragging ? "#f9f9f9" : "#fff",
        opacity: isDragging ? 0.8 : 1,
        cursor: "grab",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "relative",
    };

    return (
        <div ref={setNodeRef} style={style}>
            <div className="d-flex align-items-center justify-content-start"
                style={{ width: "70%", height: "100%" }}
                {...attributes}
                {...listeners}>
                {item?.files[0] ? <div>
                    <img src={`${URL}${item?.files[0]}`} alt="" className="h120px w120px" />
                </div> : null}
                <div className="ml-3">
                    <div>
                        <strong>
                            {item?.title?.[lang] && item?.title?.[lang].trim() !== ""
                                ? item.title[lang]
                                : <span style={{ color: "#aaa", fontStyle: "italic" }}></span>
                            }
                        </strong>
                    </div>
                    <div>
                        <span>
                            {item?.description ? item?.description[lang] : null}
                        </span>
                    </div>
                </div>
            </div>

            <ItemActions
                contentTitle={contentTitle}
                contentUrl={contentUrl}
                item={item}
                setModal={setModal}
                deleteData={deleteData}
                setSelectedItem={setSelectedItem}
                navigation={navigation}
                t={t}
            />
        </div>
    );
}

export function SortableList({ list = [], contentTitle, contentUrl, onChange, setChanged, setModal, deleteData, setSelectedItem }) {
    const [items, setItems] = useState([]);

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 8,
            },
        })
    );

    useEffect(() => {
        console.log("SortableList: list prop changed", list.length);
        setItems(list);
    }, [list]);

    const handleDragEnd = (event) => {
        const { active, over } = event;
        console.log("Drag ended", { active, over });

        if (active && over && active.id !== over.id) {
            const oldIndex = items.findIndex((i) => String(i.id) === String(active.id));
            const newIndex = items.findIndex((i) => String(i.id) === String(over.id));

            console.log("girdi 1")

            if (oldIndex !== -1 && newIndex !== -1) {
                console.log("girdi 2")
                const newItems = arrayMove(items, oldIndex, newIndex);
                setItems(newItems);

                console.log("Items reordered", {
                    oldIndex,
                    newIndex,
                    movedItemId: active.id
                });

                onChange(newItems);
                setChanged(prev => !prev);
            }
        }
    };

    React.useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            .action-button {
                transition: all 0.2s;
            }
            .action-button:hover {
                transform: translateX(-3px);
            }
            .action-button button {
                cursor: pointer;
                padding: 4px 8px;
                border-radius: 4px;
                width: 100%;
                text-align: left;
            }
            .action-button button:hover {
                background-color: rgba(0,0,0,0.05);
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    const validItems = items.filter(item => item && item.id !== undefined && item.id !== null);

    return (
        <DndContext
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
            sensors={sensors}
        >
            <SortableContext
                items={validItems.map(i => String(i.id))}
                strategy={verticalListSortingStrategy}
            >
                <div className="sortable-list">
                    {validItems.map((item) => (
                        <SortableItem
                            contentTitle={contentTitle}
                            contentUrl={contentUrl}
                            key={item.id}
                            item={{ ...item, id: String(item.id) }}
                            setModal={setModal}
                            deleteData={deleteData}
                            setSelectedItem={setSelectedItem}
                        />
                    ))}
                </div>
            </SortableContext>
        </DndContext>
    );
}